import './VehiclesSelectTable.scss';
import * as React from 'react';
import { uniqueValuesForKey } from '@shared/utils/utils-object';
import { VehiclesService } from '@shared/vehicles/VehiclesService';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';

interface IState {
    isLoading: boolean;
    vehicles: IVehicle[];
}

export class VehiclesSelectTable extends React.Component<
    {
        excludeVehicleIds?: number[];
        checkedUuids: string[];
        onChange?: (uuids: string[]) => void;
    },
    IState
> {
    state: IState = {
        isLoading: true,
        vehicles: [],
    };

    filteredRows = [];

    componentDidMount() {
        VehiclesService.fetchForActiveProject().done(vehicles => {
            vehicles = vehicles
                .filter(v => !v.onHold && v.activeProject && v.activeProject.id == kuura.getProjectId())
                .filter(v => !(this.props.excludeVehicleIds || []).includes(v.id))
                .map(vd => {
                    vd.selected = false;
                    return vd;
                });

            this.setState({
                vehicles,
                isLoading: false,
            });
            this.filteredRows = vehicles;
        });
    }

    render() {
        return (
            <div className='tab-wrapper vehicle-select-table'>
                <DataTable
                    value={this.state.vehicles}
                    scrollable
                    scrollHeight='300px'
                    filterDisplay='row'
                    filterDelay={200}
                    cellMemo={false}
                    loading={this.state.isLoading}
                    emptyMessage={__('general.no_results_found')}
                    onValueChange={r => this.onFilterChanged(r)}
                    onRowClick={row => this.toggleRow(row.data.uuid)}
                    rowClassName={row => ({ clickable: true, 'p-highlight': this.props.checkedUuids.includes(row.uuid) })}
                >
                    <Column
                        style={{ flexBasis: 50, flexGrow: 0 }}
                        header={
                            <div style={{ width: 40, textAlign: 'center' }}>
                                <input type='checkbox' onChange={e => this.toggleAllVisibleRows(e.currentTarget.checked)} />
                            </div>
                        }
                        body={row => (
                            <div style={{ width: 40, textAlign: 'center' }}>
                                <input type='checkbox' onChange={() => this.toggleRow(row.uuid)} checked={!!this.props.checkedUuids.includes(row.uuid)} />
                            </div>
                        )}
                    ></Column>

                    <Column
                        header={__('general.make')}
                        field='vendorString'
                        filter
                        showFilterMenu={false}
                        filterField='vendorString'
                        showClearButton={false}
                        filterElement={opts => (
                            <select onChange={e => this.onFilterChange(opts, e)}>
                                <option value='all'>{kuura.getMessage('general.all')}</option>
                                {uniqueValuesForKey(this.state.vehicles, 'vendor').map(val => (
                                    <option value={VehiclesService.VendorsIndexedOptions[val]?.title} key={val}>
                                        {VehiclesService.VendorsIndexedOptions[val] ? VehiclesService.VendorsIndexedOptions[val].title : val}
                                    </option>
                                ))}
                            </select>
                        )}
                    />
                    <Column
                        header={__('general.type')}
                        field='typeString'
                        filter
                        showFilterMenu={false}
                        filterField='typeString'
                        showClearButton={false}
                        filterElement={opts => (
                            <select onChange={e => this.onFilterChange(opts, e)}>
                                <option value='all'>{kuura.getMessage('general.all')}</option>
                                {uniqueValuesForKey(this.state.vehicles, 'type').map(val => (
                                    <option value={VehiclesService.TypesIndexedOptions[val]?.title} key={val}>
                                        {VehiclesService.TypesIndexedOptions[val] ? VehiclesService.TypesIndexedOptions[val].title : val}
                                    </option>
                                ))}
                            </select>
                        )}
                    />
                    <Column header={__('general.name')} field='name' filter showFilterMenu={false} filterMatchMode='contains' />
                </DataTable>
            </div>
        );
    }

    onFilterChanged = rows => {
        this.filteredRows = rows;
    };

    toggleRow = (uuid: string) => {
        if (this.props.checkedUuids.includes(uuid)) {
            this.props.onChange(this.props.checkedUuids.filter(r => r !== uuid));
        } else {
            this.props.onChange([...this.props.checkedUuids, uuid]);
        }
    };

    deselectAll = () => {
        this.props.onChange([]);
    };

    toggleAllVisibleRows(state: boolean) {
        if (state) {
            this.props.onChange(this.filteredRows.map(c => c.uuid));
        } else {
            this.deselectAll();
        }
    }

    private onFilterChange = (opts, e) => {
        const val = e.currentTarget.value;
        opts.filterApplyCallback(val === 'all' ? null : e.currentTarget.value);
    };
}
